@import "../../global/temporary-mercury-overrides/_button.scss";

:host {
  position: relative;
  display: grid;
  block-size: 100%;
  overflow: auto;
  grid-template-rows: 1fr max-content;

  // WA: Prevent a custom css rule on genexus-web from overriding --control-border-width value.
  // TDOO: remove this when the custom style is removed from genexus-web.
  // custom stlye is: .gx-struct-editor .tabular-grid-cell {
  //   --control-border-width: 0;
  // }

  --control-border-width: 1px;
  --control-border-radius: 4px;
}

.main {
  display: contents;
}

.selected-category {
  margin: 0;
  text-transform: capitalize;
  margin-inline-start: 16px; // TODO: Create a semantic class in Mercury for this case.
  white-space: nowrap;
}

.footer {
  overflow: auto;
  padding: var(--spacing-padding-m);
}

// WA: Reduce font-size. This should be solved on Mercury.
.list-box::part(item__action),
.list-box::part(group__action) {
  font-size: var(--font-size-body-s) !important;
}

// WA: There is no icon for [*]. This should be added to the icon library,
// and use a ch-image instead.
.pseudo-icon {
  inline-size: var(--icon-m);
  block-size: var(--icon-m);
  display: flex;
  align-items: center;
  justify-content: center;
}
